import { Col, Row } from "react-bootstrap";
import { CrudPlaceholderInput } from "../../../../general/modules/commons/crud/inputs/crudPlaceholderInput";

export const CustomerMutateFormTemplate = () => {
  return (
    <Row>
      <Col md="8">
        <CrudPlaceholderInput name="name" />
      </Col>
      <Col md="12">
        <CrudPlaceholderInput name="email_address" />
      </Col>
      <Col md="6">
        <CrudPlaceholderInput name="phone_number" />
      </Col>
      <Col md="6" />
      <Col md="6">
        <CrudPlaceholderInput name="postal_code" />
      </Col>
      <Col md="8">
        <CrudPlaceholderInput name="street" />
      </Col>
      <Col md="4" />
      <Col md="4">
        <CrudPlaceholderInput name="house_number" />
      </Col>
      <Col md="4">
        <CrudPlaceholderInput name="house_number_addition" />
      </Col>
      <Col md="4" />
      <Col md="6">
        <CrudPlaceholderInput name="city" />
      </Col>
      <Col md="6">
        <CrudPlaceholderInput name="country" />
      </Col>
    </Row>
  );
};
